import { EventEmitter } from "@angular/core";
import { ResourceForHelpService } from '../../entities/resource-for-help/resource-for-help.service';
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { AccountService } from '../../core/auth/account.service';
import * as i0 from "@angular/core";
import * as i1 from "../../entities/resource-for-help/resource-for-help.service";
import * as i2 from "@ng-bootstrap/ng-bootstrap";
import * as i3 from "../../core/auth/account.service";
import * as i4 from "../../ng-jhipster/language/jhi-translate.directive";
import * as i5 from "@angular/common";
function ResourcesForHelpComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 7);
} }
function ResourcesForHelpComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" Resources not found for region ", ctx_r1.user.region, ". ");
} }
function ResourcesForHelpComponent_div_6_th_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "th", 20);
} }
function ResourcesForHelpComponent_div_6_tr_11_td_11_Template(rf, ctx) { if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "td");
    i0.ɵɵelementStart(1, "a", 22);
    i0.ɵɵlistener("click", function ResourcesForHelpComponent_div_6_tr_11_td_11_Template_a_click_1_listener() { i0.ɵɵrestoreView(_r11); const i_r7 = i0.ɵɵnextContext().index; const ctx_r9 = i0.ɵɵnextContext(2); return ctx_r9.selectResource(i_r7); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(2, "svg", 23);
    i0.ɵɵelement(3, "use", 24);
    i0.ɵɵelementEnd();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelement(4, "span", 25);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function ResourcesForHelpComponent_div_6_tr_11_Template(rf, ctx) { if (rf & 1) {
    const _r13 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelementStart(1, "td");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "td", 21);
    i0.ɵɵlistener("click", function ResourcesForHelpComponent_div_6_tr_11_Template_td_click_3_listener() { const restoredCtx = i0.ɵɵrestoreView(_r13); const r_r6 = restoredCtx.$implicit; const ctx_r12 = i0.ɵɵnextContext(2); return ctx_r12.navigateTo(r_r6.link); });
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "td");
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "td");
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "td");
    i0.ɵɵtext(10);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(11, ResourcesForHelpComponent_div_6_tr_11_td_11_Template, 5, 0, "td", 5);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const r_r6 = ctx.$implicit;
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(r_r6.name);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(r_r6.link);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(r_r6.description);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(r_r6.country);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(r_r6.address);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r4.isCoach);
} }
function ResourcesForHelpComponent_div_6_div_13__svg_use_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(0, "use", 33);
} }
function ResourcesForHelpComponent_div_6_div_13__svg_use_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(0, "use", 34);
} }
function ResourcesForHelpComponent_div_6_div_13_div_10_Template(rf, ctx) { if (rf & 1) {
    const _r22 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "a", 35);
    i0.ɵɵlistener("click", function ResourcesForHelpComponent_div_6_div_13_div_10_Template_a_click_1_listener() { i0.ɵɵrestoreView(_r22); const i_r15 = i0.ɵɵnextContext().index; const ctx_r20 = i0.ɵɵnextContext(2); return ctx_r20.selectResource(i_r15); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(2, "svg", 23);
    i0.ɵɵelement(3, "use", 24);
    i0.ɵɵelementEnd();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelement(4, "span", 25);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function ResourcesForHelpComponent_div_6_div_13_div_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "h5", 36);
    i0.ɵɵelementStart(2, "p", 37);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "h5", 38);
    i0.ɵɵelementStart(5, "p", 37);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(7, "h5", 39);
    i0.ɵɵelementStart(8, "p", 37);
    i0.ɵɵtext(9);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(10, "h5", 40);
    i0.ɵɵelementStart(11, "p");
    i0.ɵɵtext(12);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const r_r14 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(r_r14.link);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(r_r14.description);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(r_r14.country);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(r_r14.address);
} }
function ResourcesForHelpComponent_div_6_div_13_Template(rf, ctx) { if (rf & 1) {
    const _r25 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 26);
    i0.ɵɵelementStart(1, "div", 27);
    i0.ɵɵlistener("click", function ResourcesForHelpComponent_div_6_div_13_Template_div_click_1_listener() { const restoredCtx = i0.ɵɵrestoreView(_r25); const i_r15 = restoredCtx.index; const ctx_r24 = i0.ɵɵnextContext(2); return ctx_r24.showResource(i_r15); });
    i0.ɵɵelement(2, "h5", 28);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(3, "svg", 29);
    i0.ɵɵtemplate(4, ResourcesForHelpComponent_div_6_div_13__svg_use_4_Template, 1, 0, "use", 30);
    i0.ɵɵtemplate(5, ResourcesForHelpComponent_div_6_div_13__svg_use_5_Template, 1, 0, "use", 31);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(6, "div", 32);
    i0.ɵɵelementStart(7, "div");
    i0.ɵɵelementStart(8, "p");
    i0.ɵɵtext(9);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(10, ResourcesForHelpComponent_div_6_div_13_div_10_Template, 5, 0, "div", 5);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(11, ResourcesForHelpComponent_div_6_div_13_div_11_Template, 13, 4, "div", 5);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const r_r14 = ctx.$implicit;
    const i_r15 = ctx.index;
    const ctx_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", ctx_r5.selectedIndex !== i_r15);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r5.selectedIndex === i_r15);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(r_r14.name);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r5.isCoach);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r5.selectedIndex === i_r15);
} }
function ResourcesForHelpComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8);
    i0.ɵɵelementStart(1, "table", 9);
    i0.ɵɵelementStart(2, "thead");
    i0.ɵɵelementStart(3, "tr", 10);
    i0.ɵɵelement(4, "th", 11);
    i0.ɵɵelement(5, "th", 12);
    i0.ɵɵelement(6, "th", 13);
    i0.ɵɵelement(7, "th", 14);
    i0.ɵɵelement(8, "th", 15);
    i0.ɵɵtemplate(9, ResourcesForHelpComponent_div_6_th_9_Template, 1, 0, "th", 16);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "tbody");
    i0.ɵɵtemplate(11, ResourcesForHelpComponent_div_6_tr_11_Template, 12, 6, "tr", 17);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "div", 18);
    i0.ɵɵtemplate(13, ResourcesForHelpComponent_div_6_div_13_Template, 12, 5, "div", 19);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(9);
    i0.ɵɵproperty("ngIf", ctx_r2.isCoach);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r2.isFiltered ? ctx_r2.filteredResources : ctx_r2.resources);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r2.isFiltered ? ctx_r2.filteredResources : ctx_r2.resources);
} }
export class ResourcesForHelpComponent {
    constructor(resourceForHelpService, modalService, accountService) {
        this.resourceForHelpService = resourceForHelpService;
        this.modalService = modalService;
        this.accountService = accountService;
        this.resourceSelected = new EventEmitter();
        this.isFiltered = false;
        this.isCoach = this.accountService.isCoach();
    }
    ngOnInit() {
        console.log("ResourcesForHelpComponent");
        this.resourceForHelpService.queryAsList().subscribe(res => {
            this.resources = res.body;
            this.filteredResources = this.resources.filter(r => this.user.country === r.country || (this.user.country !== r.country && r.region === 'Global'));
            if (this.filteredResources.length !== this.resources.length) {
                this.isFiltered = true;
            }
            console.log(this.resources);
            console.log(this.filteredResources);
        });
    }
    resourcesLoaded() {
        var _a;
        return ((_a = this.resources) === null || _a === void 0 ? void 0 : _a.length) > 0;
    }
    navigateTo(link) {
        window.open(link, "_blank");
    }
    selectResource(index) {
        const r = this.resources[index];
        let messageText = `<b>A helpful resource:</b><br>${r.name}<br>${r.description}
        ${r.link !== null ? "<br>" + r.link : ""}
        ${r.phoneNumber !== null ? "<br>" + r.phoneNumber : ""}
        ${r.email !== null ? "<br>" + r.email : ""}
        ${r.address !== null ? "<br>" + r.address : ""}
        ${r.country !== null ? r.country : ""}`;
        this.resourceSelected.emit({ resource: messageText });
        this.modalService.dismissAll();
    }
    showResource(index) {
        if (this.selectedIndex !== index) {
            this.selectedIndex = index;
        }
        else {
            this.selectedIndex = null;
        }
    }
}
ResourcesForHelpComponent.ɵfac = function ResourcesForHelpComponent_Factory(t) { return new (t || ResourcesForHelpComponent)(i0.ɵɵdirectiveInject(i1.ResourceForHelpService), i0.ɵɵdirectiveInject(i2.NgbModal), i0.ɵɵdirectiveInject(i3.AccountService)); };
ResourcesForHelpComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ResourcesForHelpComponent, selectors: [["resources-for-help"]], inputs: { user: "user" }, outputs: { resourceSelected: "resourceSelected" }, decls: 7, vars: 4, consts: [[1, "d-flex", "justify-content-between"], ["jhiTranslate", "sessionChat.header.resources"], [1, "btn-link", 3, "jhiTranslate", "click"], ["id", "resourcesList"], ["jhiTranslate", "sessionChat.word.loading", 4, "ngIf"], [4, "ngIf"], ["class", "resources-list", 4, "ngIf"], ["jhiTranslate", "sessionChat.word.loading"], [1, "resources-list"], [1, "table", "table-sm", "table-hover", "d-none", "d-xl-block"], [1, "table-header"], ["scope", "col", "jhiTranslate", "sessionChat.resources", 1, "col-1"], ["scope", "col", "jhiTranslate", "sessionChat.link", 1, "col-3"], ["scope", "col", "jhiTranslate", "sessionChat.description", 1, "col-3"], ["scope", "col", "jhiTranslate", "sessionChat.country", 1, "col-1"], ["scope", "col", "jhiTranslate", "sessionChat.contact", 1, "col-3"], ["scope", "col", "class", "col-1", 4, "ngIf"], [4, "ngFor", "ngForOf"], [1, "d-xl-none", "mt-4"], ["class", "mb-3 pr-2", 4, "ngFor", "ngForOf"], ["scope", "col", 1, "col-1"], [1, "share-text", 3, "click"], [1, "d-flex", "justify-content-center", "align-items-center", 3, "click"], [1, "angle-icon", 2, "height", "18px", "width", "17px"], [0, "xlink", "href", "../../../../content/images/sprite.svg?v=3#share"], ["jhiTranslate", "sessionChat.share", 1, "share-text"], [1, "mb-3", "pr-2"], [1, "d-flex", "justify-content-between", "align-items-center", "resource-header", 3, "click"], ["jhiTranslate", "sessionChat.resources", 2, "font-weight", "600", "max-width", "80%"], [1, "angle-icon"], [0, "xlink", "href", "../../../../content/images/sprite.svg?v=3#angle-down", 4, "ngIf"], [0, "xlink", "href", "../../../../content/images/sprite.svg?v=3#angle-up", 4, "ngIf"], [1, "mt-4", "mb-4"], [0, "xlink", "href", "../../../../content/images/sprite.svg?v=3#angle-down"], [0, "xlink", "href", "../../../../content/images/sprite.svg?v=3#angle-up"], [1, "d-flex", "justify-content-start", "align-items-center", 3, "click"], ["jhiTranslate", "sessionChat.link"], [1, "mb-4"], ["jhiTranslate", "sessionChat.description"], ["jhiTranslate", "sessionChat.country"], ["jhiTranslate", "sessionChat.contact"]], template: function ResourcesForHelpComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelement(1, "h4", 1);
        i0.ɵɵelementStart(2, "a", 2);
        i0.ɵɵlistener("click", function ResourcesForHelpComponent_Template_a_click_2_listener() { return ctx.isFiltered = !ctx.isFiltered; });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(3, "div", 3);
        i0.ɵɵtemplate(4, ResourcesForHelpComponent_div_4_Template, 1, 0, "div", 4);
        i0.ɵɵtemplate(5, ResourcesForHelpComponent_div_5_Template, 2, 1, "div", 5);
        i0.ɵɵtemplate(6, ResourcesForHelpComponent_div_6_Template, 14, 3, "div", 6);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵpropertyInterpolate("jhiTranslate", ctx.isFiltered ? "sessionChat.seeAll" : "sessionChat.seeYours");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", !ctx.resources);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", (ctx.resources == null ? null : ctx.resources.length) === 0);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.resourcesLoaded());
    } }, directives: [i4.JhiTranslateDirective, i5.NgIf, i5.NgForOf], styles: [".resources-list[_ngcontent-%COMP%]{max-height:600px !important;overflow-y:scroll !important;overflow-x:scroll !important}.table-header[_ngcontent-%COMP%]{background:#f7f4eb !important;border:none !important}table[_ngcontent-%COMP%], thead[_ngcontent-%COMP%], tbody[_ngcontent-%COMP%], th[_ngcontent-%COMP%]{border:none !important}.share-text[_ngcontent-%COMP%]{margin-left:5px;text-decoration:underline;color:#44a38b;font-weight:bold;cursor:pointer}table[_ngcontent-%COMP%]   thead[_ngcontent-%COMP%]{position:sticky;top:-1px}.angle-icon[_ngcontent-%COMP%]{height:12px;width:22px}"] });
